import React, { useRef, useState } from "react";
import { Button } from "semantic-ui-react";
import { sendNotification } from '../utils/notify';
import { trackEvent } from '../utils/analytics';
import EmailSuggestion, { useEmailSuggestion } from './EmailSuggestion';
import "../styles/SubscribeForm.scss";

function SubscribeForm({ compact = false }) {
  const [emailSent, setEmailSent] = useState(false);
  const [emailSending, setEmailSending] = useState(false);
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const emailHint = useEmailSuggestion(email);
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault(); // prevents the page from reloading when you hit “Send”
    setEmailSending(true);
    setError('');

    const fd = new FormData(form.current);
    try {
      await sendNotification({
        type: 'newsletter',
        first_name: fd.get('first_name'),
        last_name: fd.get('last_name'),
        email: fd.get('email'),
      });
      setEmailSending(false);
      setEmailSent(true);
      trackEvent('newsletter_signup');
    } catch (err) {
      // Clear the sending state so the button doesn't hang on "Loading", and show a
      // recovery path so a failed signup isn't silently lost.
      console.error('Newsletter signup failed:', err);
      setEmailSending(false);
      setError("Something went wrong, please try again, or email lily@lilylaisf.com.");
      trackEvent('newsletter_signup_error');
    }
  };

  return (
    <div className="subscribe-form">
      <div className="form">
        <form ref={form} onSubmit={sendEmail} className="form-fields">
          <label>First Name</label>
          <input
            type="text"
            name="first_name"
            placeholder="First Name"
            required
          />
          <label>Last Name</label>
          <input type="text" name="last_name" required placeholder="Last Name"/>
          <label>Email Address</label>
          <input type="email" name="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} onBlur={emailHint.onBlur}/>
          <EmailSuggestion suggestion={emailHint.suggestion} onAccept={setEmail} />
          {!emailSent && !emailSending && <Button type='submit' basic>Subscribe</Button>}
          {!emailSent && emailSending && <Button loading basic>Loading</Button>}
          {emailSent && !emailSending && <Button disabled basic>Subscribed!</Button>}
          {error && <p className="subscribe-error" role="alert">{error}</p>}
        </form>
      </div>

      {!compact && (
        <div className="subscribe-copyright">
          © {new Date().getFullYear()} Lily Lai Real Estate | All rights reserved.
        </div>
      )}
    </div>
  );
}

export default SubscribeForm;
